
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BASE_URL } from '@elevate-workspace/auth';
import { Observable } from 'rxjs';
import {  WishlistResponse } from '../../../shared/interface/wishlist';

@Injectable({
  providedIn: 'root'
})
export class WishlistService {
  _HttpClient = inject(HttpClient);
 _Baseurl=inject(BASE_URL)
 getWishlistData():Observable<WishlistResponse>{
    return this._HttpClient.get<WishlistResponse>(this._Baseurl+'api/v1/wishlist');
  }
 addWishlistData(productId:string):Observable<WishlistResponse>{
    return this._HttpClient.post<WishlistResponse>(this._Baseurl+'api/v1/wishlist',{productId});
  }
 removeWishlistData(productId:string):Observable<WishlistResponse>{
    return this._HttpClient.delete<WishlistResponse>(this._Baseurl+`api/v1/wishlist/${productId}`);
  }
 clearWishlistData():Observable<WishlistResponse>{
    return this._HttpClient.post<WishlistResponse>(this._Baseurl+`api/v1/wishlist/clear`,{});
  }
  
}
